// © Microsoft Corporation. All rights reserved.

import { perfMarkerEndSuffix, perfMarkerStartSuffix } from "../constants";

/** PerfMarker interface for storing startTime and endMeasure callback. */
interface PerfMarker {
    endMeasure: (updatedDynamicMeasureName?: string) => void,
    startTime: number
}

/** Start and end markers. */
const _perfMarkers = {};

/** PageTimings. */
export const _pageTimings = {};

/** PerfTimeline to use for recording the values. */
let _perfTimeline: any;

/**
 * Returns the pageTimings.
 * @return The pageTimings.
 */
export function getPerfMarkerHelperPageTimings() {
    return _pageTimings;
}

/**
 * Sets the perf timeline and the pagetimings.
 * Defaults perfTimeline to undefined.
 * @param perfTimeline - The perf timeline object
 */
export function initializePerfMarkerHelper(perfTimeline: any) {
    _perfTimeline = perfTimeline;
}

/**
 * Records the time stamp of the given marker.
 * Perf marker with StartSuffix should be called first, otherwise it will not do anything.
 * @param name - The marker name
 * @return An object storing the perfMarker name and the total time taken (end - start).
 */
export function addPerfMarker(name: string): { name: string; timeTaken: number; } {
    if (name.endsWith(perfMarkerStartSuffix)) {
        name = name.slice(0, name.length - perfMarkerStartSuffix.length);
        const newMarker: PerfMarker = {
            endMeasure: _perfTimeline && _perfTimeline.startMeasure(name).endMeasure,
            startTime: performance.now()
        };
        _perfMarkers[name] = newMarker;
        return;
    }

    if (name.endsWith(perfMarkerEndSuffix)) {
        name = name.slice(0, name.length - perfMarkerEndSuffix.length);
        if (_perfMarkers[name]) {
            const { endMeasure, startTime } = _perfMarkers[name];
            const timeTaken = Math.round(performance.now() - startTime);
            _pageTimings[name] = timeTaken;
            if (endMeasure) {
                endMeasure();
            }
            return {
                name,
                timeTaken
            };
        }
        return;
    }
}